import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { InvoiceState } from './state';

const defaultState: InvoiceState = {
  invoices: [],
};

export const invoiceModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
